import TableCell from '@tiptap/extension-table-cell';

export const TableCellWithColor = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      stainedColor: {
        default: null,
        parseHTML: (el: HTMLElement) => el.getAttribute('data-stained-color') || null,
        renderHTML: (attrs: { stainedColor?: string | null }) => {
          if (!attrs.stainedColor) {
            return {};
          }
          return {
            'data-stained-color': attrs.stainedColor,
            style: `background-color: ${attrs.stainedColor};`,
          };
        },
      },
    };
  },
});

export default TableCellWithColor;
